import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import ProfileUpdate from "./ProfileUpdate";
import { useDispatch, useSelector } from "react-redux";
import ViewProfile from "./ViewProfile";
import { Header,Sidebar } from "../Layout";
import { Loading } from "../../shared";
import { loadUserProfile } from "../../../actions/authAction";
import { LOAD_PROFILE_RESET } from "../../../constants/actionTypes";

const Profile = () => {

    const dispatch = useDispatch();
    const { loading, user } = useSelector(state => state.updateProfile)
    useEffect(() => {
        dispatch({ type: LOAD_PROFILE_RESET })
        dispatch(loadUserProfile())
    }, [dispatch])
    if (loading) {
        return (
            <Loading/>
        );
    }
    return (
        <>
        <Header/>
        <Sidebar/>
        <div id="main-content">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h2>Profile</h2>
                    </div>            
                    <div className="col-md-6 col-sm-12 text-right">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                            <li className="breadcrumb-item active">Profile</li>
                        </ul>
                    </div>
                </div>
            </div>
        <div className="container-fluid">           

            <div className="row clearfix">
              {/* Profile View */}
                <ViewProfile />
                {/* Update Profile */}
                <ProfileUpdate data={user}/>
            </div>
        </div>
        </div>
        </>
    );
}
export default Profile;